import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';



@Injectable()
export class AutomationService {

  constructor(private http: HttpClient) {
  }

  executeContext(executionContext): Promise<any> {

    const self = this;
    return new Promise((resolve, reject) => {
      //self.http.post('https://hsbwinservices.tk/api/v2/io/execution/context',
      self.http.post('https://automation.hsbservices.com/api/v2/io/execution/context', 
      
      executionContext)
      .subscribe((data: any) => {
        resolve(data);
      }, error => {
        //this.errorStack.append(error, true);
        reject(error);
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/automation.service.ts